var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircledPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 4H7.7V7.2H4.5V8.8H7.7V12H9.3V8.8H12.5V7.2H9.3V4ZM8.5 0C4.084 0 0.5 3.584 0.5 8C0.5 12.416 4.084 16 8.5 16C12.916 16 16.5 12.416 16.5 8C16.5 3.584 12.916 0 8.5 0ZM8.5 14.4C4.972 14.4 2.1 11.528 2.1 8C2.1 4.472 4.972 1.6 8.5 1.6C12.028 1.6 14.9 4.472 14.9 8C14.9 11.528 12.028 14.4 8.5 14.4Z",
    fill: "#2371C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledPlus);
export default __webpack_public_path__ + "static/media/circledPlus.919bd5ddd195eb5fcdb2e5a32fc067f3.svg";
export { ForwardRef as ReactComponent };